import React from "react";
import {
  Alert as BootstrapAlert,
  AlertProps as BootstrapAlertProps,
} from "react-bootstrap";

export interface AlertProps extends Omit<BootstrapAlertProps, "variant"> {
  variant?:
    | "primary"
    | "secondary"
    | "success"
    | "danger"
    | "warning"
    | "info"
    | "light"
    | "dark";
  dismissible?: boolean;
  onClose?: () => void;

  children: React.ReactNode;
}

export const Alert: React.FC<AlertProps> = ({
  variant = "info",
  dismissible = false,
  onClose,
  show = true,
  children,
  className = "",
  ...props
}) => {
  if (!show) return null;

  return (
    <BootstrapAlert
      variant={variant}
      dismissible={dismissible}
      onClose={onClose}
      className={className}
      {...props}
    >
      {children}
    </BootstrapAlert>
  );
};

export { Alert as default };
